const OffsetToXPosition = {
  3600: 0,
  7200: 22,
  10800: 44,
  14400: 66,
  18000: 88,
  21600: 110,
  25200: 132,
  0: 154,
  86400: 176,
  172800: 198,
  259200: 220,
  345600: 242,
  432000: 264,
  518400: 286,
  604800: 308,
  691200: 330,
  777600: 352,
  864000: 374,
  950400: 396,
  1036800: 418,
  1123200: 440,
  1209600: 462,
  1296000: 484,
  1382400: 506,
  1468800: 528,
  1555200: 550,
  1641600: 572,
  1728000: 594,
  1814400: 616,
  1900800: 638,
  1987200: 660,
  2073600: 682,
  2160000: 704,
  2246400: 726,
  2332800: 748,
  2419200: 770,
  2505600: 792,
  2592000: 814,
}

export default OffsetToXPosition



// WEBPACK FOOTER //
// ./src/components/sitewide/OffsetToXPosition.js